<h2 mat-dialog-title>{{ 'SelectSecurityRoles' | translate: {Default: "Select Work Roles"} }}</h2>

<mat-dialog-content>
    <div *ngIf="selectedSecurityRoles.length > 0" class="selected-goal page-description-section">
        <h6>{{ 'SelectedSecurityRoles' | translate: {Default: "Selected Security Roles"} }}: 
            <span *ngFor="let securityRole of selectedSecurityRoles; index as i">
                <span *ngIf="i > 0">, </span>{{securityRole.name}}
            </span>
        </h6>
    </div>

    <app-data-grid-comp
        class="select-security-roles-data-grid"
        [columns]="columns"
        [gridDataResult]="gridDataResult"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [skip]="skip"
        category=""
        [rowSelectionSettings]="selectionSettings"
        [selectedRowsButtonSettings]="{
            show: false
        }"
        [selectedItems]="selectedSecurityRolesIds"
        clickableRows="true"
        hideActionButtons="true"
        searchable="true"
        [filterCategories]="columns"
        [clearSelectedItems]="clearSelectedItems"
        [filterToggleDetails]="filterToggleDetails"
        [sortable]="{
            mode: 'multiple'
        }"
        [sortableColumns]="sortableColumns"
        (emitGridStateChangeEvent)="gridStateChange($event)"
        (emitSelectedRows)="selectedRowsChanged($event)"
    ></app-data-grid-comp>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="selectedSecurityRoles.length === 0">{{ 'Save' | translate: {Default: "Save"} }}</button>
</mat-dialog-actions>